import { FC, ReactNode } from "react";

export interface FilterCountBadgeProps {
  /** The content rendered inside the badge (usually a number). */
  count: ReactNode;
}

/**
 * Small blue pill showing the number of active selections on a filter trigger.
 */
export const FilterCountBadge: FC<FilterCountBadgeProps> = ({ count }) => (
  <span className="ml-2 bg-brand text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
    {count}
  </span>
);
